import React, { useEffect } from "react";

import Main from '../components/MansoryMesh/Main'
import Projects from "../components/Home/Projects";
import Liam from "../components/Home/Liam";
import WhyWait from "../components/Home/WhyWait";
import MeshSizes from "../components/MansoryMesh/MeshSizes";
import MeshThick from "../components/MansoryMesh/MeshThick";

import PhysicalAndMechanical from "../components/MansoryMesh/PhysicalAndMechanical";

import Advantages from "../components/MansoryMesh/Advantages";
import ChooseComposite from "../components/MansoryMesh/ChooseComposite";
import MeshSizesAvailable from "../components/MansoryMesh/MeshSizesAvailable";
import ApplicationsMasonryMesh from "../components/MansoryMesh/ApplicationsMasonryMesh";

function MansoryMesh () {
 
    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);
      
    return(
        <div className="bg-[#1D1D1D] relative overflow-hidden">
            <Main/>
            {/* <MeshSizes/> */}
            {/* <MeshThick/>*/}
            <PhysicalAndMechanical/>
            <MeshSizesAvailable/>
            {/* <Advantages/>
            <ChooseComposite/> */}
            <ApplicationsMasonryMesh/>
            <Projects/>
            {/* <Liam/>
            <WhyWait/> */}
        </div>
    );
}

export default MansoryMesh;